import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M15 27.5c6.904 0 12.5-5.596 12.5-12.5S21.904 2.5 15 2.5 2.5 8.096 2.5 15 8.096 27.5 15 27.5zM15 10v10M10 15h10" stroke="#0073FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>);